//Version:0.0.1
//Author:Harsha
//Last Edit:Harsha
//Modified Date:26-08-2025
import { FIN_API_URL } from '../../../const';
import { makeApiCall } from '../../../_common/api.utils';
/**************************** START - GET ALL INSTRUMENTS LIST DETAILS EXPORT FUNCTION ***********************/
export const getAllListInstrument = (payload: any) => {
	const data = {
		getInstrumentListDetailsToken: payload,
	};
	const url = `${FIN_API_URL}getAllInstrumentList`;
	return makeApiCall(url, data);
};
/**************************** END - GET ALL INSTRUMENTS LIST DETAILS EXPORT FUNCTION *************************/

/**************************** START - CREATE INSTRUMENTS LIST DETAILS EXPORT FUNCTION ************************/
export const createInstrumentDetails = (payload: any) => {
	const data = {
		createInstrumentListDetailsToken: payload,
	};
	const url = `${FIN_API_URL}createInstrument`;
	return makeApiCall(url, data);
};
/**************************** END - CREATE INSTRUMENTS LIST DETAILS EXPORT FUNCTION ***************************/

/********************* START - GET PARTICULAR INSTRUMENTS LIST DETAILS EXPORT FUNCTION ************************/
export const getInstrumentInfo = (payload: any) => {
	const data = {
		getParticularInstrumentListDetailsToken: payload,
	};
	const url = `${FIN_API_URL}getParticularInstrument`;
	return makeApiCall(url, data);
};
/********************** END - GET PARTICULAR INSTRUMENTS LIST DETAILS EXPORT FUNCTION **************************/
export const deleteInstrumentDetails = (payload: any) => {
	const data = {
		deleteInstrumentDetailsToken: payload,
	};
	const url = `${FIN_API_URL}deleteInstrument`;
	return makeApiCall(url, data);
};
/*********************** END - GET PARTICULAR INSTRUMENTS LIST DETAILS EXPORT FUNCTION *************************/

/************************** START - UPDATE INSTRUMENTS LIST DETAILS EXPORT FUNCTION ****************************/
export const updateInstrumentDetails = (payload: any) => {
	const data = {
		updateInstrumentDataToken: payload,
	};
	const url = `${FIN_API_URL}updateInstrument`;
	return makeApiCall(url, data);
};
/************************** END - UPDATE INSTRUMENTS LIST DETAILS EXPORT FUNCTION ****************************/
